import { render, staticRenderFns } from "./AdditionalContractForm.vue?vue&type=template&id=6707c166&scoped=true&"
import script from "./AdditionalContractForm.vue?vue&type=script&lang=js&"
export * from "./AdditionalContractForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6707c166",
  null
  
)

export default component.exports